import { z } from 'zod';

/** 对外错误码（需求 §2.2 / 04-API设计）。新增只能追加，不能改变既有语义。 */
export const ERROR_CODES = {
  invalid_request: { status: 400, retryable: false },
  invalid_api_key: { status: 401, retryable: false },
  unauthenticated: { status: 401, retryable: false },
  quota_exceeded: { status: 402, retryable: false },
  key_limit_exceeded: { status: 402, retryable: false },
  permission_denied: { status: 403, retryable: false },
  csrf_failed: { status: 403, retryable: false },
  account_suspended: { status: 403, retryable: false },
  not_found: { status: 404, retryable: false },
  /** 当前站点不提供该功能（如国内站访问数字货币充值） */
  not_available: { status: 404, retryable: false },
  /** 需先同意《充值须知》 */
  terms_required: { status: 403, retryable: false },
  idempotency_conflict: { status: 409, retryable: false },
  conflict: { status: 409, retryable: false },
  asset_in_use: { status: 409, retryable: false },
  group_not_empty: { status: 409, retryable: false },
  invalid_parameter: { status: 422, retryable: false },
  asset_not_ready: { status: 422, retryable: true },
  authorization_required: { status: 422, retryable: false },
  rate_limited: { status: 429, retryable: true },
  internal_error: { status: 500, retryable: true },
  no_available_channel: { status: 503, retryable: true },
} as const;

export type ErrorCode = keyof typeof ERROR_CODES;

/** 任务失败码：出现在任务对象的 error 字段中，不改变已返回的 202。 */
export const TASK_FAILURE_CODES = [
  'no_available_channel',
  'upstream_status_unknown',
  'task_deadline_exceeded',
  'content_rejected',
  'asset_rejected',
  'invalid_parameter',
  'account_suspended',
  'result_unavailable',
  'internal_error',
] as const;
export type TaskFailureCode = (typeof TASK_FAILURE_CODES)[number];

export const ApiErrorBodySchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    param: z.string().optional(),
    retryable: z.boolean(),
    request_id: z.string(),
  }),
});
export type ApiErrorBody = z.infer<typeof ApiErrorBodySchema>;
